<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion de projets</h2>
    <p class="page-subtitle">Suivez et gérez l'ensemble des projets</p>
  </div>
  <button (click)="openCreateDialog()" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouveau Projet
  </button>
</div>

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange($event)"
          placeholder="Rechercher un projet..." class="search-input">
      </div>
      <select class="filter-select" [ngModel]="selectedStatusId ?? ''" (ngModelChange)="onStatusFilterChange($event)">
        <option value="">Tous les statuts</option>
        @for (status of statusOptions(); track status.id) {
        <option [value]="status.id">{{ status.name }}</option>
        }
      </select>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived()" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivés
        </label>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField">
      <thead>
        <tr>
          <th mat-sort-header="name">Nom du projet</th>
          <th mat-sort-header="deliveryAddress">Adresse</th>
          <th mat-sort-header="city">Ville / CP</th>
          <th mat-sort-header="availabilityDate">Mise à disposition</th>
          <th mat-sort-header="deliveryDate">Livraison</th>
          <th>Statut</th>
          @if (isAdmin()) {
          <th class="text-right">Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (project of projects(); track project.id) {
        <tr [routerLink]="['/projects/edit', project.id]" class="clickable-row" [class.archived-row]="project.archived">
          <td class="font-bold">{{ project.name }}</td>
          <td>{{ project.deliveryAddress }}</td>
          <td>{{ project.city }} {{ project.zipCode }}</td>
          <td>{{ project.availabilityDate | date:'dd/MM/yyyy' }}</td>
          <td>{{ project.deliveryDate | date:'dd/MM/yyyy' }}</td>
          <td>
            <span class="status-badge" [attr.data-meta]="project.metaStatus"
              [style.background-color]="project.statusColor" [style.color]="project.statusColor ? 'white' : null">
              {{ project.statusName || project.metaStatus }}
            </span>
            @if (project.archived) {
              <span class="badge-archived" style="margin-left:8px;">Archivé</span>
            }
          </td>
          @if (isAdmin()) {
          <td class="text-right">
            @if (canDeleteProject(project)) {
              <button class="btn-icon btn-danger" (click)="$event.stopPropagation(); deleteProject(project)"
                title="Supprimer le projet">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </td>
          }
        </tr>
        } @empty {
        <tr class="empty-row">
          <td [attr.colspan]="isAdmin() ? 7 : 6">
            <div class="empty-state">
              <mat-icon class="empty-icon" aria-hidden="true">inbox</mat-icon>
              <p>Aucun projet trouvé</p>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalElements()" [pageSize]="size()" [pageSizeOptions]="[5, 10, 25, 100]"
    (page)="onPageChange($event)" aria-label="Sélectionner la page">
  </mat-paginator>
</div>

@if (isDialogOpen()) {
<app-project-create-dialog (close)="closeCreateDialog()" (created)="onProjectCreated()">
</app-project-create-dialog>
}

@if (showDeleteDialog()) {
<app-confirm-dialog title="Supprimer le projet"
  [message]="'Êtes-vous sûr de vouloir supprimer le projet ' + (projectToDelete()?.name || '') + ' ? Cette action est irréversible et supprimera toutes les données associées (FAT, documents, etc.).'"
  (confirmed)="confirmDelete()" (cancelled)="cancelDelete()">
</app-confirm-dialog>
}
